import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
import {Cartesian2, Cartesian3, Color, DistanceDisplayCondition} from "cesium";
/**
 *摄像头图层
 */
class CameraLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.CAMERA;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.forEach((obj) =>{
            let item={...obj};
            item.layerName=self.layerName;
            if(item.longitude&&item.latitude&&item.longitude!='null'&&item.latitude!='null'){
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(Number(item.longitude),Number(item.latitude), CONSTANTS.ALTITUDE),
                    name: item.name,
                    id:item.id,
                    attributes:item,
                    //立广告牌
                    billboard :{
                        image : require("@/assets/img/map/camera.png"),
                        show : true,
                        width : 48,
                        height : 48,
                        pixelOffset:new Cesium.Cartesian2(-10, 0),
                        heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
                    },
                    label:{
                        text : item.name,
                        color :Color.fromCssColorString('#fff'),
                        //backgroundColor:Color.fromCssColorString('#fff'),
                        zIndex:1000000,
                        font:'normal 32px MicroSoft YaHei',
                        showBackground : true,
                        scale : 0.4,
                        distanceDisplayCondition : new DistanceDisplayCondition(0, 500),
                        pixelOffset:new Cartesian2(-10, 30),
                        eyeOffset:new Cartesian3(0,0,-100),
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });

    }
}
export default CameraLayer;
